import { useInView } from "@/hooks/useInView";

export default function VictorySection() {
  const [ref, inView] = useInView();

  return (
    <section id="victory" data-testid="victory-section" className="bg-[#111111] py-16 sm:py-24" ref={ref}>
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <p className={`text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-6 reveal ${inView ? "visible" : ""}`}>
          The Transformation
        </p>
        <h2
          className={`font-heading font-black text-[#F2EFE9] mb-8 reveal ${inView ? "visible" : ""} stagger-1`}
          style={{
            fontSize: "clamp(2.25rem, 5.5vw, 3.75rem)",
            lineHeight: 1.05,
            letterSpacing: "-0.02em",
          }}
        >
          From victim to victory mindset.
        </h2>
        <p className={`text-[#D5CFC8] font-body text-base sm:text-lg leading-relaxed max-w-2xl mx-auto reveal ${inView ? "visible" : ""} stagger-2`}>
          3SM helps people move from fear, uncertainty, and powerlessness toward awareness, confidence, composure, and responsible action. Victory does not always mean fighting. It means recognizing your options, trusting your preparation, and responding with purpose.
        </p>
      </div>
    </section>
  );
}
